<template>
  <naj-modal
    ref="attorneyModal"
    :title="isInternalAttorney? local.attorney.attorneyModalTitle: local.attorney.attorneyDoc"
    :width="900"
    :footer="true"
    :show-footer-close-button="true"
    @onClose="onModalClose"
  >
    <div
      v-if="loadAttorney"
      class="attorney-loader"
    >
      <naj-loader></naj-loader>
    </div>

    <template v-else>
      <template v-if="attorneyData">
        <p
          v-if="isInternalAttorney"
          class="attorney-text"
        >
          {{ attorneyData }}
        </p>

        <div
          v-if="isExternalAttorney"
          class="attachment-file-viewer pdf-file"
        >
          <div class="pdf-container">
            <div class="pdf-wrapper">
              <div class="pdf-holder">
                <embed :src="fileUrl">
              </div>
            </div>
          </div>
        </div>
      </template>
      <p
        v-else
        class="attorney-text"
      >
        {{ local.attorney.showAttorneyError }}
      </p>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('SystemModule');
import { writingsOfJusticeEnum } from '@/helpers/enum.js';
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

export default {
  name: 'AttorneyModal',
  props: {
    attorneyCode: {
      type: String,
      required: true,
    },
    attorneyType: {
      type: Number,
      default: writingsOfJusticeEnum.internalAttorney,
    },
    attorneyDetails: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    modalVisibility: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      attorneyData: null,
      loadAttorney: false,
      writingsOfJusticeEnum,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(`data:application/pdf;base64,${this.attorneyData}`, false);
    },
    isInternalAttorney() {
      // eslint-disable-next-line eqeqeq
      return this.attorneyType == writingsOfJusticeEnum.internalAttorney;
    },
    isExternalAttorney() {
      // eslint-disable-next-line eqeqeq
      return this.attorneyType == writingsOfJusticeEnum.externalAttorney;
    },
  },
  methods: {
    ...mapActions(['getAttorneyDetails']),
    onModalClose() {
      this.$emit('onClose');
    },
    show() {
      this.callGetAttorney();
      this.$refs.attorneyModal.show();
    },
    close() {
      this.$refs.attorneyModal.close();
    },
    callGetAttorney() {
      if ((this.attorneyDetails || {}).attorneyNumber) {
        this.attorneyData = this.isInternalAttorney ? this.attorneyDetails.attorneyText : this.attorneyDetails.binary;
      } else {
        this.loadAttorney = true;
        this.getAttorneyDetails(this.attorneyCode)
          .then((res) => {
            this.attorneyData = this.isInternalAttorney ? res.attorneyText : res.binary;
          })
          .catch(() => {
            this.attorneyData = null;
            this.$emit('onError');
          })
          .finally(() => (this.loadAttorney = false));
      }
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.show();
      } else {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attorney-loader {
  padding: 30px 0;
}
.attorney-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}

.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}

embed {
  width: 500px;
  height: 500px;
  display: block;
}
</style>
